"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20021ToJSON = exports.InlineResponse20021FromJSONTyped = exports.InlineResponse20021FromJSON = void 0;
var _1 = require("./");
function InlineResponse20021FromJSON(json) {
    return InlineResponse20021FromJSONTyped(json, false);
}
exports.InlineResponse20021FromJSON = InlineResponse20021FromJSON;
function InlineResponse20021FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventTypes': (json['eventTypes'].map(_1.OWEventTypeResponseFromJSON)),
    };
}
exports.InlineResponse20021FromJSONTyped = InlineResponse20021FromJSONTyped;
function InlineResponse20021ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventTypes': (value.eventTypes.map(_1.OWEventTypeResponseToJSON)),
    };
}
exports.InlineResponse20021ToJSON = InlineResponse20021ToJSON;
